const Maintenance=()=>{
    return <>
        <div style={{height:"100vh",display:"flex",alignItems:"center", justifyContent:"center"}}>
            <p style={{fontFamily:"sans-serif",fontSize:"40px"}}>Maintenance Mode</p>
        </div>
    </>
}

export default Maintenance